module.exports = __webpack_public_path__ + "img/index.2364956d.jpg";